import React, {useEffect, useState} from 'react';
import {NavLink, Link} from 'react-router-dom';

import Logo from './../assets/logoA.png'
import LogoWhite from './../assets/logoB.png';

function Header(){

    /* for sticky header */
	const [headerFix, setheaderFix] = React.useState(false);
	useEffect(() => {
		window.addEventListener("scroll", () => {
			setheaderFix(window.scrollY > 50);
		});
	}, []); 

    const [sidebarOpen, setSidebarOpen] = useState(false);	
     
    return(
        <>
            <header className="site-header mo-left header header-transparent style-1">
                <div className={`sticky-header main-bar-wraper navbar-expand-lg ${headerFix ? "is-fixed" : ""}`}>
                    <div className="main-bar clearfix">
                        <div className="container clearfix">
                            <div className="logo-header">
                                <Link to={"/"} className="logo-dark">
                                    <img src={Logo} alt="Kelowna Duct Cleaning" style={{width:'33%'}} onError={(e)=>{ e.target.style.display='none'; e.target.nextSibling?.classList?.add('show'); }} />
                                    <span className="logo-text" style={{display:'none', fontWeight:700, color:'#23508C', fontSize:'1.25rem'}}>Kelowna Duct Cleaning</span>
                                </Link>
                                <Link to={"/"} className="logo-light">
                                    <img src={LogoWhite} alt="Kelowna Duct Cleaning" style={{width:'50%'}} onError={(e)=>{ e.target.style.display='none'; e.target.nextSibling?.classList?.add('show'); }} />
                                    <span className="logo-text" style={{display:'none', fontWeight:700, color:'#fff', fontSize:'1.25rem'}}>Kelowna Duct Cleaning</span>
                                </Link>
                            </div>
                            
                            <button  type="button"
                                className={`navbar-toggler  navicon justify-content-end ${sidebarOpen ? 'open' : 'collapsed' }`} 
                                onClick={()=>setSidebarOpen(!sidebarOpen)}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>                            
                         
                            <div className={`header-nav navbar-collapse collapse justify-content-end ${sidebarOpen ? "show" : ""}`} id="navbarNavDropdown" >
                                <div className="logo-header mostion">
                                    <Link to="/" className="logo-dark">
                                        <img style={{borderRadius:'16px', width:'33%'}} src={Logo} alt="Kelowna Duct Cleaning" />
                                    </Link>
                                </div>                            
                                <ul className="nav navbar-nav navbar">
                                    <li><NavLink exact to="/" >Home</NavLink></li>
                                    <li><NavLink exact to="about-us" >About Us</NavLink></li>
                                    <li><NavLink exact to="/why-us" >Why Us</NavLink></li>
                                    <li><NavLink exact to="/services" >Services</NavLink></li>
                                    <li><NavLink exact to="/review" >Reviews</NavLink></li>
                                    <li><NavLink to="/contact-us" >Quote</NavLink></li>
                                    <li><NavLink exact to="/contact-us" >Contact Us</NavLink></li>
                                </ul>                               
                            </div>
                            
                        </div>
                    </div>

                </div>
            </header>
        </>
    )
}
export default Header;